class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    this.updateProgressBarOnExternalCartUpdate();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add("animate", "active");
      CustomJS.setupLazyVideos();
      this.updateProgressBar();
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  updateProgressBar() {
    const freeShippingThreshold = window.cart_free_shiping;
    const discountThreshold = window.cart_discount

    const progressSegment = document.querySelector(".progress-segment");
    if (!progressSegment) return;

    const savedWidth = localStorage.getItem("progressBarWidth");
    if (savedWidth !== null) {
      progressSegment.style.width = `${savedWidth}%`;
    }

    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        const cartTotal = cart.original_total_price / 100;

        const cartProgressEl = document.querySelector(".cart-progress-message");
        if (!cartProgressEl) return;

        let message = '';
        let progressPercent = 0;

        if (cartTotal >= discountThreshold) {
          message = "You qualify for 10% OFF!";
          progressPercent = 100;
        } else if (cartTotal >= freeShippingThreshold) {
          const diffToDiscount = (discountThreshold - cartTotal).toFixed(2);
          message = `You are $${diffToDiscount} away from 10% OFF`;
          progressPercent = (cartTotal / discountThreshold) * 100;
        } else {
          const diffToFreeShip = (freeShippingThreshold - cartTotal).toFixed(2);
          message = `You are $${diffToFreeShip} away from Free Shipping`;
          progressPercent = (cartTotal / discountThreshold) * 100;
        }

        progressSegment.style.width = `${Math.min(progressPercent, 100)}%`;
        cartProgressEl.textContent = message;
        cartProgressEl.style.visibility = "visible";

        localStorage.setItem("progressBarWidth", progressPercent);
      })
      .catch((err) => {
        console.error("Error updating progress bar:", err);
      });
      CountdownBar.init();
      CustomJS.setupCartRecommendations('cart-recommendations-desktop-container');
      CustomJS.setupCartRecommendations('cart-recommendations-mobile-container');
      CustomJS.initAnnouncementLottie()
  }

   updateProgressBarOnExternalCartUpdate() {
    document.addEventListener("cart:updated", () => {
      this.updateProgressBar();
    });
   }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
      document.dispatchEvent(new CustomEvent("cart:updated"));
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
